import {State} from "./types";

export const initialState: State = {
  shown: false,
  type: "success",
  durationMS: 5000,
  title: undefined,
  message: undefined,
};
